/* eslint-disable max-lines */
export var colorTokens = {
  textStyle: {
    body: {
      default: function _default(_ref) {
        var token = _ref.token;
        return token('palette.slate.900');
      },
      contrast: function contrast(_ref2) {
        var token = _ref2.token;
        return token('palette.slate.50');
      },
      subtext: function subtext(_ref3) {
        var token = _ref3.token;
        return token('palette.grey.700');
      },
      hint: function hint(_ref4) {
        var token = _ref4.token;
        return token('palette.grey.600');
      },
      error: function error(_ref5) {
        var token = _ref5.token;
        return token('palette.red.600');
      },
      disabled: function disabled(_ref6) {
        var token = _ref6.token;
        return token('palette.grey.500');
      }
    },
    link: {
      idle: {
        default: function _default(_ref7) {
          var token = _ref7.token;
          return token('palette.indigo.600');
        },
        contrast: function contrast(_ref8) {
          var token = _ref8.token;
          return token('palette.indigo.300');
        }
      },
      hover: {
        default: function _default(_ref9) {
          var token = _ref9.token;
          return token('palette.indigo.500');
        },
        contrast: function contrast(_ref10) {
          var token = _ref10.token;
          return token('palette.indigo.200');
        }
      },
      active: {
        default: function _default(_ref11) {
          var token = _ref11.token;
          return token('palette.indigo.400');
        },
        contrast: function contrast(_ref12) {
          var token = _ref12.token;
          return token('palette.indigo.100');
        }
      }
    },
    primary: {
      idle: {
        default: function _default(_ref13) {
          var token = _ref13.token;
          return token('palette.indigo.700');
        },
        contrast: function contrast(_ref14) {
          var token = _ref14.token;
          return token('palette.indigo.50');
        }
      },
      hover: {
        default: function _default(_ref15) {
          var token = _ref15.token;
          return token('palette.indigo.600');
        },
        contrast: function contrast(_ref16) {
          var token = _ref16.token;
          return token('palette.indigo.100');
        }
      },
      active: {
        default: function _default(_ref17) {
          var token = _ref17.token;
          return token('palette.indigo.500');
        },
        contrast: function contrast(_ref18) {
          var token = _ref18.token;
          return token('palette.indigo.200');
        }
      }
    },
    secondary: {
      idle: {
        default: function _default(_ref19) {
          var token = _ref19.token;
          return token('palette.indigo.500');
        },
        contrast: function contrast(_ref20) {
          var token = _ref20.token;
          return token('palette.indigo.300');
        }
      },
      hover: {
        default: function _default(_ref21) {
          var token = _ref21.token;
          return token('palette.indigo.400');
        },
        contrast: function contrast(_ref22) {
          var token = _ref22.token;
          return token('palette.indigo.400');
        }
      },
      active: {
        default: function _default(_ref23) {
          var token = _ref23.token;
          return token('palette.indigo.300');
        },
        contrast: function contrast(_ref24) {
          var token = _ref24.token;
          return token('palette.indigo.500');
        }
      }
    },
    information: {
      idle: {
        default: function _default(_ref25) {
          var token = _ref25.token;
          return token('palette.blue.900');
        },
        contrast: function contrast(_ref26) {
          var token = _ref26.token;
          return token('palette.blue.50');
        }
      },
      hover: {
        default: function _default(_ref27) {
          var token = _ref27.token;
          return token('palette.blue.800');
        },
        contrast: function contrast(_ref28) {
          var token = _ref28.token;
          return token('palette.blue 100');
        }
      },
      active: {
        default: function _default(_ref29) {
          var token = _ref29.token;
          return token('palette.blue.700');
        },
        contrast: function contrast(_ref30) {
          var token = _ref30.token;
          return token('palette.blue.200');
        }
      }
    },
    success: {
      idle: {
        default: function _default(_ref31) {
          var token = _ref31.token;
          return token('palette.green.900');
        },
        contrast: function contrast(_ref32) {
          var token = _ref32.token;
          return token('palette.green.50');
        }
      },
      hover: {
        default: function _default(_ref33) {
          var token = _ref33.token;
          return token('palette.green.800');
        },
        contrast: function contrast(_ref34) {
          var token = _ref34.token;
          return token('palette.green.100');
        }
      },
      active: {
        default: function _default(_ref35) {
          var token = _ref35.token;
          return token('palette.green.700');
        },
        contrast: function contrast(_ref36) {
          var token = _ref36.token;
          return token('palette.green.200');
        }
      }
    },
    warning: {
      idle: {
        default: function _default(_ref37) {
          var token = _ref37.token;
          return token('palette.grey.900');
        },
        contrast: function contrast(_ref38) {
          var token = _ref38.token;
          return token('palette.grey.50');
        }
      },
      hover: {
        default: function _default(_ref39) {
          var token = _ref39.token;
          return token('palette.grey.800');
        },
        contrast: function contrast(_ref40) {
          var token = _ref40.token;
          return token('palette.grey.100');
        }
      },
      active: {
        default: function _default(_ref41) {
          var token = _ref41.token;
          return token('palette.grey.700');
        },
        contrast: function contrast(_ref42) {
          var token = _ref42.token;
          return token('palette.grey.200');
        }
      }
    },
    danger: {
      idle: {
        default: function _default(_ref43) {
          var token = _ref43.token;
          return token('palette.red.600');
        },
        contrast: function contrast(_ref44) {
          var token = _ref44.token;
          return token('palette.red.50');
        }
      },
      hover: {
        default: function _default(_ref45) {
          var token = _ref45.token;
          return token('palette.red.500');
        },
        contrast: function contrast(_ref46) {
          var token = _ref46.token;
          return token('palette.red.100');
        }
      },
      active: {
        default: function _default(_ref47) {
          var token = _ref47.token;
          return token('palette.red.400');
        },
        contrast: function contrast(_ref48) {
          var token = _ref48.token;
          return token('palette.red.200');
        }
      }
    }
  },
  primary: {
    idle: {
      default: function _default(_ref49) {
        var token = _ref49.token;
        return token('palette.indigo.700');
      },
      contrast: function contrast(_ref50) {
        var token = _ref50.token;
        return token('palette.indigo.50');
      }
    },
    hover: {
      default: function _default(_ref51) {
        var token = _ref51.token;
        return token('palette.indigo.600');
      },
      contrast: function contrast(_ref52) {
        var token = _ref52.token;
        return token('palette.indigo.100');
      }
    },
    active: {
      default: function _default(_ref53) {
        var token = _ref53.token;
        return token('palette.indigo.500');
      },
      contrast: function contrast(_ref54) {
        var token = _ref54.token;
        return token('palette.indigo.200');
      }
    },
    selected: {
      default: function _default(_ref55) {
        var token = _ref55.token;
        return token('palette.indigo.500');
      },
      contrast: function contrast(_ref56) {
        var token = _ref56.token;
        return token('palette.indigo.200');
      }
    }
  },
  secondary: {
    idle: {
      default: function _default(_ref57) {
        var token = _ref57.token;
        return token('palette.white');
      },
      contrast: function contrast(_ref58) {
        var token = _ref58.token;
        return token('palette.indigo.200');
      }
    },
    hover: {
      default: function _default(_ref59) {
        var token = _ref59.token;
        return token('palette.indigo.100');
      },
      contrast: function contrast(_ref60) {
        var token = _ref60.token;
        return token('palette.indigo.100');
      }
    },
    active: {
      default: function _default(_ref61) {
        var token = _ref61.token;
        return token('palette.indigo.200');
      },
      contrast: function contrast(_ref62) {
        var token = _ref62.token;
        return token('palette.indigo.50');
      }
    },
    selected: {
      default: function _default(_ref63) {
        var token = _ref63.token;
        return token('palette.indigo.200');
      },
      contrast: function contrast(_ref64) {
        var token = _ref64.token;
        return token('palette.indigo.50');
      }
    }
  },
  information: {
    idle: {
      default: function _default(_ref65) {
        var token = _ref65.token;
        return token('palette.blue.800');
      },
      contrast: function contrast(_ref66) {
        var token = _ref66.token;
        return token('palette.blue.300');
      }
    },
    hover: {
      default: function _default(_ref67) {
        var token = _ref67.token;
        return token('palette.blue.700');
      },
      contrast: function contrast(_ref68) {
        var token = _ref68.token;
        return token('palette.blue.400');
      }
    },
    active: {
      default: function _default(_ref69) {
        var token = _ref69.token;
        return token('palette.blue.600');
      },
      contrast: function contrast(_ref70) {
        var token = _ref70.token;
        return token('palette.blue.500');
      }
    },
    selected: {
      default: function _default(_ref71) {
        var token = _ref71.token;
        return token('palette.blue.600');
      },
      contrast: function contrast(_ref72) {
        var token = _ref72.token;
        return token('palette.blue.500');
      }
    }
  },
  success: {
    idle: {
      default: function _default(_ref73) {
        var token = _ref73.token;
        return token('palette.green.900');
      },
      contrast: function contrast(_ref74) {
        var token = _ref74.token;
        return token('palette.green.300');
      }
    },
    hover: {
      default: function _default(_ref75) {
        var token = _ref75.token;
        return token('palette.green.800');
      },
      contrast: function contrast(_ref76) {
        var token = _ref76.token;
        return token('palette.green.400');
      }
    },
    active: {
      default: function _default(_ref77) {
        var token = _ref77.token;
        return token('palette.green.700');
      },
      contrast: function contrast(_ref78) {
        var token = _ref78.token;
        return token('palette.green.500');
      }
    },
    selected: {
      default: function _default(_ref79) {
        var token = _ref79.token;
        return token('palette.green.700');
      },
      contrast: function contrast(_ref80) {
        var token = _ref80.token;
        return token('palette.green.500');
      }
    }
  },
  warning: {
    idle: {
      default: function _default(_ref81) {
        var token = _ref81.token;
        return token('palette.yellow.500');
      },
      contrast: function contrast(_ref82) {
        var token = _ref82.token;
        return token('palette.yellow.300');
      }
    },
    hover: {
      default: function _default(_ref83) {
        var token = _ref83.token;
        return token('palette.yellow.400');
      },
      contrast: function contrast(_ref84) {
        var token = _ref84.token;
        return token('palette.yellow.400');
      }
    },
    active: {
      default: function _default(_ref85) {
        var token = _ref85.token;
        return token('palette.yellow.300');
      },
      contrast: function contrast(_ref86) {
        var token = _ref86.token;
        return token('palette.yellow.500');
      }
    },
    selected: {
      default: function _default(_ref87) {
        var token = _ref87.token;
        return token('palette.yellow.300');
      },
      contrast: function contrast(_ref88) {
        var token = _ref88.token;
        return token('palette.yellow.500');
      }
    }
  },
  danger: {
    idle: {
      default: function _default(_ref89) {
        var token = _ref89.token;
        return token('palette.red.600');
      },
      contrast: function contrast(_ref90) {
        var token = _ref90.token;
        return token('palette.red.300');
      }
    },
    hover: {
      default: function _default(_ref91) {
        var token = _ref91.token;
        return token('palette.red.500');
      },
      contrast: function contrast(_ref92) {
        var token = _ref92.token;
        return token('palette.red.400');
      }
    },
    active: {
      default: function _default(_ref93) {
        var token = _ref93.token;
        return token('palette.red.400');
      },
      contrast: function contrast(_ref94) {
        var token = _ref94.token;
        return token('palette.red.500');
      }
    },
    selected: {
      default: function _default(_ref95) {
        var token = _ref95.token;
        return token('palette.red.400');
      },
      contrast: function contrast(_ref96) {
        var token = _ref96.token;
        return token('palette.red.500');
      }
    }
  },
  neutral: {
    idle: {
      default: function _default(_ref97) {
        var token = _ref97.token;
        return token('palette.grey.400');
      },
      contrast: function contrast(_ref98) {
        var token = _ref98.token;
        return token('palette.grey.200');
      }
    },
    hover: {
      default: function _default(_ref99) {
        var token = _ref99.token;
        return token('palette.grey.300');
      },
      contrast: function contrast(_ref100) {
        var token = _ref100.token;
        return token('palette.grey.300');
      }
    },
    active: {
      default: function _default(_ref101) {
        var token = _ref101.token;
        return token('palette.grey.200');
      },
      contrast: function contrast(_ref102) {
        var token = _ref102.token;
        return token('palette.grey.400');
      }
    },
    selected: {
      default: function _default(_ref103) {
        var token = _ref103.token;
        return token('palette.grey.200');
      },
      contrast: function contrast(_ref104) {
        var token = _ref104.token;
        return token('palette.grey.400');
      }
    }
  },
  input: {
    idle: function idle(_ref105) {
      var token = _ref105.token;
      return token('palette.white');
    },
    active: function active(_ref106) {
      var token = _ref106.token;
      return token('palette.indigo.100');
    },
    selected: function selected(_ref107) {
      var token = _ref107.token;
      return token('palette.indigo.700');
    },
    error: function error(_ref108) {
      var token = _ref108.token;
      return token('palette.red.600');
    },
    disabled: {
      default: function _default(_ref109) {
        var token = _ref109.token;
        return token('palette.grey.50');
      },
      dark: function dark(_ref110) {
        var token = _ref110.token;
        return token('palette.grey.300');
      }
    }
  },
  container: {
    interactive: {
      idle: function idle(_ref111) {
        var token = _ref111.token;
        return token('palette.white');
      },
      hover: function hover(_ref112) {
        var token = _ref112.token;
        return token('palette.indigo.100');
      },
      active: function active(_ref113) {
        var token = _ref113.token;
        return token('palette.indigo.200');
      },
      selected: function selected(_ref114) {
        var token = _ref114.token;
        return token('palette.indigo.200');
      }
    },
    static: {
      default: function _default(_ref115) {
        var token = _ref115.token;
        return token('palette.white');
      },
      contrast: function contrast(_ref116) {
        var token = _ref116.token;
        return token('palette.grey.200');
      },
      dark: function dark(_ref117) {
        var token = _ref117.token;
        return token('palette.grey.900');
      },
      primary: {
        default: function _default(_ref118) {
          var token = _ref118.token;
          return token('palette.indigo.700');
        },
        contrast: function contrast(_ref119) {
          var token = _ref119.token;
          return token('palette.indigo.600');
        }
      },
      secondary: {
        default: function _default(_ref120) {
          var token = _ref120.token;
          return token('palette.indigo.50');
        },
        contrast: function contrast(_ref121) {
          var token = _ref121.token;
          return token('palette.indigo.200');
        }
      },
      information: {
        default: function _default(_ref122) {
          var token = _ref122.token;
          return token('palette.blue.100');
        },
        contrast: function contrast(_ref123) {
          var token = _ref123.token;
          return token('palette.blue.300');
        }
      },
      success: {
        default: function _default(_ref124) {
          var token = _ref124.token;
          return token('palette.green.100');
        },
        contrast: function contrast(_ref125) {
          var token = _ref125.token;
          return token('palette.green.300');
        }
      },
      warning: {
        default: function _default(_ref126) {
          var token = _ref126.token;
          return token('palette.yellow.100');
        },
        contrast: function contrast(_ref127) {
          var token = _ref127.token;
          return token('palette.yellow.300');
        }
      },
      danger: {
        default: function _default(_ref128) {
          var token = _ref128.token;
          return token('palette.red.100');
        },
        contrast: function contrast(_ref129) {
          var token = _ref129.token;
          return token('palette.red.300');
        }
      }
    }
  },
  border: {
    input: {
      idle: function idle(_ref130) {
        var token = _ref130.token;
        return token('palette.grey.600');
      },
      hover: function hover(_ref131) {
        var token = _ref131.token;
        return token('palette.indigo.700');
      },
      focus: function focus(_ref132) {
        var token = _ref132.token;
        return token('palette.indigo.300');
      },
      active: function active(_ref133) {
        var token = _ref133.token;
        return token('palette.indigo.700');
      },
      selected: function selected(_ref134) {
        var token = _ref134.token;
        return token('palette.indigo.700');
      },
      error: function error(_ref135) {
        var token = _ref135.token;
        return token('palette.red.600');
      },
      disabled: function disabled(_ref136) {
        var token = _ref136.token;
        return token('palette.grey.500');
      }
    },
    container: {
      interactive: {
        idle: function idle(_ref137) {
          var token = _ref137.token;
          return token('palette.grey.200');
        },
        hover: function hover(_ref138) {
          var token = _ref138.token;
          return token('palette.indigo.400');
        }
      },
      static: {
        light: function light(_ref139) {
          var token = _ref139.token;
          return token('palette.grey.300');
        },
        medium: function medium(_ref140) {
          var token = _ref140.token;
          return token('palette.grey.500');
        },
        dark: function dark(_ref141) {
          var token = _ref141.token;
          return token('palette.grey.700');
        },
        contrast: function contrast(_ref142) {
          var token = _ref142.token;
          return token('palette.grey.50');
        }
      }
    },
    primary: {
      idle: {
        default: function _default(_ref143) {
          var token = _ref143.token;
          return token('palette.indigo.700');
        },
        contrast: function contrast(_ref144) {
          var token = _ref144.token;
          return token('palette.indigo.50');
        }
      },
      hover: {
        default: function _default(_ref145) {
          var token = _ref145.token;
          return token('palette.indigo.600');
        },
        contrast: function contrast(_ref146) {
          var token = _ref146.token;
          return token('palette.indigo.100');
        }
      },
      active: {
        default: function _default(_ref147) {
          var token = _ref147.token;
          return token('palette.indigo.500');
        },
        contrast: function contrast(_ref148) {
          var token = _ref148.token;
          return token('palette.indigo.200');
        }
      },
      selected: {
        default: function _default(_ref149) {
          var token = _ref149.token;
          return token('palette.indigo.500');
        },
        contrast: function contrast(_ref150) {
          var token = _ref150.token;
          return token('palette.indigo.200');
        }
      }
    },
    secondary: {
      idle: {
        default: function _default(_ref151) {
          var token = _ref151.token;
          return token('palette.white');
        },
        contrast: function contrast(_ref152) {
          var token = _ref152.token;
          return token('palette.indigo.200');
        }
      },
      hover: {
        default: function _default(_ref153) {
          var token = _ref153.token;
          return token('palette.indigo.100');
        },
        contrast: function contrast(_ref154) {
          var token = _ref154.token;
          return token('palette.indigo.100');
        }
      },
      active: {
        default: function _default(_ref155) {
          var token = _ref155.token;
          return token('palette.indigo.200');
        },
        contrast: function contrast(_ref156) {
          var token = _ref156.token;
          return token('palette.indigo.50');
        }
      },
      selected: {
        default: function _default(_ref157) {
          var token = _ref157.token;
          return token('palette.indigo.200');
        },
        contrast: function contrast(_ref158) {
          var token = _ref158.token;
          return token('palette.indigo.50');
        }
      }
    },
    information: {
      idle: {
        default: function _default(_ref159) {
          var token = _ref159.token;
          return token('palette.blue.800');
        },
        contrast: function contrast(_ref160) {
          var token = _ref160.token;
          return token('palette.blue.300');
        }
      },
      hover: {
        default: function _default(_ref161) {
          var token = _ref161.token;
          return token('palette.blue.700');
        },
        contrast: function contrast(_ref162) {
          var token = _ref162.token;
          return token('palette.blue.400');
        }
      },
      active: {
        default: function _default(_ref163) {
          var token = _ref163.token;
          return token('palette.blue.600');
        },
        contrast: function contrast(_ref164) {
          var token = _ref164.token;
          return token('palette.blue.500');
        }
      },
      selected: {
        default: function _default(_ref165) {
          var token = _ref165.token;
          return token('palette.blue.600');
        },
        contrast: function contrast(_ref166) {
          var token = _ref166.token;
          return token('palette.blue.500');
        }
      }
    },
    success: {
      idle: {
        default: function _default(_ref167) {
          var token = _ref167.token;
          return token('palette.green.900');
        },
        contrast: function contrast(_ref168) {
          var token = _ref168.token;
          return token('palette.green.300');
        }
      },
      hover: {
        default: function _default(_ref169) {
          var token = _ref169.token;
          return token('palette.green.800');
        },
        contrast: function contrast(_ref170) {
          var token = _ref170.token;
          return token('palette.green.400');
        }
      },
      active: {
        default: function _default(_ref171) {
          var token = _ref171.token;
          return token('palette.green.700');
        },
        contrast: function contrast(_ref172) {
          var token = _ref172.token;
          return token('palette.green.500');
        }
      },
      selected: {
        default: function _default(_ref173) {
          var token = _ref173.token;
          return token('palette.green.700');
        },
        contrast: function contrast(_ref174) {
          var token = _ref174.token;
          return token('palette.green.500');
        }
      }
    },
    warning: {
      idle: {
        default: function _default(_ref175) {
          var token = _ref175.token;
          return token('palette.yellow.500');
        },
        contrast: function contrast(_ref176) {
          var token = _ref176.token;
          return token('palette.yellow.300');
        }
      },
      hover: {
        default: function _default(_ref177) {
          var token = _ref177.token;
          return token('palette.yellow.400');
        },
        contrast: function contrast(_ref178) {
          var token = _ref178.token;
          return token('palette.yellow.400');
        }
      },
      active: {
        default: function _default(_ref179) {
          var token = _ref179.token;
          return token('palette.yellow.300');
        },
        contrast: function contrast(_ref180) {
          var token = _ref180.token;
          return token('palette.yellow.500');
        }
      },
      selected: {
        default: function _default(_ref181) {
          var token = _ref181.token;
          return token('palette.yellow.300');
        },
        contrast: function contrast(_ref182) {
          var token = _ref182.token;
          return token('palette.yellow.500');
        }
      }
    },
    danger: {
      idle: {
        default: function _default(_ref183) {
          var token = _ref183.token;
          return token('palette.red.700');
        },
        contrast: function contrast(_ref184) {
          var token = _ref184.token;
          return token('palette.red.300');
        }
      },
      hover: {
        default: function _default(_ref185) {
          var token = _ref185.token;
          return token('palette.red.600');
        },
        contrast: function contrast(_ref186) {
          var token = _ref186.token;
          return token('palette.red.400');
        }
      },
      active: {
        default: function _default(_ref187) {
          var token = _ref187.token;
          return token('palette.red.500');
        },
        contrast: function contrast(_ref188) {
          var token = _ref188.token;
          return token('palette.red.500');
        }
      },
      selected: {
        default: function _default(_ref189) {
          var token = _ref189.token;
          return token('palette.red.500');
        },
        contrast: function contrast(_ref190) {
          var token = _ref190.token;
          return token('palette.red.500');
        }
      }
    },
    neutral: {
      idle: {
        default: function _default(_ref191) {
          var token = _ref191.token;
          return token('palette.grey.400');
        },
        contrast: function contrast(_ref192) {
          var token = _ref192.token;
          return token('palette.grey.200');
        }
      },
      hover: {
        default: function _default(_ref193) {
          var token = _ref193.token;
          return token('palette.grey.300');
        },
        contrast: function contrast(_ref194) {
          var token = _ref194.token;
          return token('palette.grey.300');
        }
      },
      active: {
        default: function _default(_ref195) {
          var token = _ref195.token;
          return token('palette.grey.200');
        },
        contrast: function contrast(_ref196) {
          var token = _ref196.token;
          return token('palette.grey.400');
        }
      },
      selected: {
        default: function _default(_ref197) {
          var token = _ref197.token;
          return token('palette.grey.200');
        },
        contrast: function contrast(_ref198) {
          var token = _ref198.token;
          return token('palette.grey.400');
        }
      }
    }
  },
  pageBackground: {
    default: function _default(_ref199) {
      var token = _ref199.token;
      return token('palette.grey.100');
    },
    alternate: function alternate(_ref200) {
      var token = _ref200.token;
      return token('palette.white');
    }
  },
  overlay: {
    default: function _default(_ref201) {
      var token = _ref201.token;
      return token('palette.shade.dark.800');
    }
  }
};